import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Row, Col, Container, Form, Modal } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logo from './mainlogo.png';
import { useHistory } from 'react-router-dom'; // Import useHistory from 'react-router-dom'
import '../pages/LoginPage.css'

const Login = () => {

    const [email, setEmail] = useState('');
    const [company, setCompany] = useState('');
    const [username, setUserName] = useState('');
    const [role, setRole] = useState('');
    const [schemaList, setSchemaList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loginDetailsData, setLoginDetailsData] = useState([]);
    const [permissionTableNames, setPermissionTableNames] = useState([]);
    const [crudPermission, setcrudPermission] = useState([]);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);


    const history = useHistory();

    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isTouchscreen, setIsTouchscreen] = useState(false);
    const [isUsernameValid, setIsUsernameValid] = useState(true);
    const [ispassValid, setIsPassvalid] = useState(true);
    const [isCompanyselected, setIsCompanySelected] = useState(true);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };


    const handleCloseModal = () => {
        setIsModalOpen(false);

    };

    const handleOpenSelectCompany = async (e) => {
        debugger;
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + `api/checkLogin/${email}/${password}`);
            setIsUsernameValid(true);
            console.log(response.data.result)
            setLoginDetailsData(response.data.result);
            const Tables = response.data.result;
            /* const tableswithCRUD = Tables.map(item => item.table);
            console.log(tableswithCRUD); */

            const crudOperations = Tables.map(item => ({
                table: item.table,
                create: item.create,
                read: item.read,
                update: item.update,
                delete: item.delete,
            }));

            setcrudPermission(crudOperations);
            console.log(crudOperations);

            const uniqueDbNames = [...new Set(Tables.map(item => item.db_name))];
            setSchemaList(uniqueDbNames);
            /* const tableNames = Tables.map(item => item.table);
            console.log(tableNames);  */
            setIsModalOpen(true);

            if (response.data.isPassValid) {
                debugger;
                const userDetails = response.data.result[0];
                // Password is valid, proceed with the login logic
                localStorage.setItem('loggedIn', 'true');
                localStorage.setItem('loginUsername', userDetails.username);
                localStorage.setItem('loginEmail', userDetails.email);
                localStorage.setItem('role', userDetails.Rolecode);
                
                setUserName(userDetails.username);
                setRole(userDetails.Rolecode);

                if (userDetails.Rolecode === 'SA') {
                    setIsSuperAdmin(true);
                } else {
                    setIsSuperAdmin(false);
                }


            } else {
                // Password is not valid
                setIsPassvalid(response.data.isPassValid);
                setPassword('');

            }
        } catch (error) {
            setIsUsernameValid(false);
            console.error('Error during login:', error);
            //alert('An error occurred during login. Please try again.');
        }
    }

    const handleSelectCompany = (companyname) => {
        localStorage.removeItem('company');
        localStorage.setItem('company', companyname);
        setCompany(companyname);
        setIsCompanySelected(true);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!company) {
            setIsCompanySelected(false);
            return;
        } else {
            if (company) {
                const tableNames = loginDetailsData
                    .filter(item => item.db_name === company)
                    .map(item => item.table);
                setPermissionTableNames(tableNames);
                console.log(tableNames);

                history.push({
                    pathname: '/DScreen',
                    state: { companyName: company, userName: username, roleCode: role, permissionTables: tableNames, crudPermissionData: crudPermission }
                });
            }
        }
    };



    //Get schemas
    const loadDatabase = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + 'api/getDatabases');
            //setSchemaList(response.data);
        } catch (error) {
            console.error('Error loading schema:', error);
        }
    };


    useEffect(() => {
        // Check if the device has a touchscreen
        loadDatabase();
        const onTouchStart = () => {
            setIsTouchscreen(true);
        };
        document.addEventListener('touchstart', onTouchStart);
        return () => {
            document.removeEventListener('touchstart', onTouchStart);
        };
    }, []);


    return (
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
            <Container fluid style={{ backgroundColor: '#f5f5f5' }}>
                <Row className="justify-content-center align-items-center">
                    <Col md={4} style={{ backgroundColor: '#F6F4F7', padding: '30px', borderRadius: '5px' }}>
                        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                            <img
                                src={logo}
                                alt="logo"
                                style={{ maxWidth: '300px', maxHeight: '300px' }}
                            />
                        </div>
                        <Form>
                            <Form.Group className="form-group">
                                <Form.Label className="custom-label" >Email</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter email"
                                    className="user-input larger-width"
                                    style={{ borderRadius: '20px' }}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {!isUsernameValid && (
                                    <p style={{ color: 'red', marginBottom: '0px' }}>Invalid Username or Email!</p>
                                )}
                            </Form.Group>


                            <Form.Group className="form-group">
                                <Form.Label className="custom-label">Password</Form.Label>
                                <div className="password-input" onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}>
                                    <Form.Control
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter password"
                                        className="user-input larger-width"
                                        style={{ borderRadius: '20px' }}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    {(isHovered || isTouchscreen) && (
                                        <Button
                                            variant="outline-secondary"
                                            className="password-toggle-btn"
                                            onClick={handleTogglePassword}
                                        >
                                            {showPassword ? <FaEye size={24} /> : <FaEyeSlash size={24} />}
                                        </Button>)}
                                </div>
                                {!ispassValid && (
                                    <p style={{ color: 'red', marginBottom: '0px' }}>Invalid Password. Try again!</p>
                                )}
                            </Form.Group>

                            <Button
                                className="login_button"
                                style={{ marginTop: '20px', backgroundColor: '#1b6db4', borderColor: '#54B4D3', width: '50%' }}
                                block
                                onClick={() => handleOpenSelectCompany()}
                            >
                                Select Company
                            </Button>
                        </Form>
                    </Col>
                </Row>
                <Modal show={isModalOpen} onHide={handleCloseModal} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                    <Form.Group className="form-group">
                        <Form.Label className="custom-label">Company</Form.Label>
                        <Form.Select
                            as="select"
                            placeholder="Select company"
                            className="user-input larger-width"
                            style={{ borderRadius: '20px' }}
                            value={company}
                            onChange={(e) => handleSelectCompany(e.target.value)}
                        >
                            <option value="">Select Company</option>
                            {isSuperAdmin && (
                                <option>control management</option>
                            )}
                            
                            {schemaList
                                .map((item, index) => (
                                    <option key={index} value={item}>
                                        {item}
                                    </option>
                                ))}
                        </Form.Select>
                        {!isCompanyselected && (
                            <p style={{ color: 'red' }}>Please Select Company</p>
                        )}
                    </Form.Group>

                    <Row>
                        <Col md={4} xs={4}></Col>
                        <Col md={6} xs={6}>
                            <Button
                                className="login_button"
                                style={{ marginTop: '20px', backgroundColor: '#1b6db4', borderColor: '#54B4D3', width: '70%' }}
                                block
                                onClick={handleSubmit}
                            >
                                Login
                            </Button>
                        </Col>
                    </Row>

                </Modal>
            </Container>
        </div>
    );
};

export default Login;
